import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import toNumber from 'lodash/toNumber';
import * as React from 'react';
export default class SearchInputField extends React.Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
    }
    componentDidMount() {
        if (this.input.current) {
            this.input.current.focus();
        }
    }
    render() {
        const { fromNumberCountryCode, value, isValidNumber, onChangeInput } = this.props;
        let prefix = null;
        if (value.indexOf('+') === -1 &&
            isNaN(toNumber(value)) === false &&
            fromNumberCountryCode !== null &&
            isValidNumber === false) {
            prefix = (_jsxs("span", Object.assign({ className: "input-group-addon" }, { children: ["+", fromNumberCountryCode] })));
        }
        return (_jsx("div", Object.assign({ className: "search-users-to-transfer" }, { children: _jsx("div", Object.assign({ className: 'form-group' }, { children: _jsxs("div", Object.assign({ className: "input-group" }, { children: [prefix, _jsx("input", { type: "search", ref: this.input, id: "search-users", className: "form-control search-users-input", placeholder: "Search contacts...", value: value, onChange: onChangeInput })] })) })) })));
    }
}
